import { Component } from '@angular/core';
import { ButtonComponent } from './button.component';

@Component({
    selector: 'app-card-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss']
})
export class CardButtonComponent extends ButtonComponent {
    constructor() {
        super();
        this.hostClass = 'card-button';
        this.type = 'link';
        this.buttonClassesCallback = () => this.buttonClassSet.add('mx-auto');
    }
}
